import React from 'react';
import { Badge } from '../ui/badge';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';

const API_BASE = process.env.REACT_APP_BACKEND_URL;

const SubstituteDialog = ({
  substituteDialog, confirmDesign,
  substituteSearch, setSubstituteSearch,
  filteredDesigns, selectSubstitute,
  getBrandName,
}) => {
  return (
    <Dialog open={!!substituteDialog} onOpenChange={(open) => { if (!open) confirmDesign(); }}>
      <DialogContent className="max-w-md z-50">
        <DialogHeader>
          <DialogTitle>Design — {substituteDialog?.product?.design_code}</DialogTitle>
        </DialogHeader>
        {substituteDialog?.product && (
          <div className="space-y-4">
            <div className="flex gap-3 items-start">
              {substituteDialog.product.images?.[0] ? (
                <img src={`${API_BASE}${substituteDialog.product.images[0]}`} alt="" className="w-28 h-28 rounded-lg object-cover border" />
              ) : (
                <div className="w-28 h-28 rounded-lg bg-gray-100 flex items-center justify-center text-2xl font-bold text-gray-400">{substituteDialog.product.design_code}</div>
              )}
              <div className="text-sm space-y-1">
                <div><strong>{substituteDialog.product.design_code}</strong></div>
                <div className="text-gray-500">{substituteDialog.product.category} — {getBrandName(substituteDialog.product.brand_id)}</div>
                <div className="flex gap-1 flex-wrap mt-1">
                  {[...new Set(substituteDialog.product.skus?.map(s => s.color))].map(c => (
                    <Badge key={c} variant="outline" className="text-xs">{c}</Badge>
                  ))}
                </div>
              </div>
            </div>
            <div className="border-t pt-3">
              <Label className="text-xs font-semibold text-gray-600 mb-1 block">Substitute design:</Label>
              <Input value={substituteSearch} onChange={e => setSubstituteSearch(e.target.value)}
                placeholder="Search substitute..." className="h-8 text-sm" data-testid="se-substitute-search" />
              {substituteSearch && (
                <div className="mt-1 border rounded-lg max-h-40 overflow-y-auto">
                  {filteredDesigns(substituteSearch).filter(p => p.id !== substituteDialog.product.id).map(p => (
                    <div key={p.id} className="px-3 py-2 hover:bg-emerald-50 cursor-pointer text-sm flex items-center gap-2"
                      onClick={() => selectSubstitute(p)}>
                      {p.images?.[0] && <img src={`${API_BASE}${p.images[0]}`} alt="" className="w-7 h-7 rounded object-cover" />}
                      <span className="font-mono font-semibold">{p.design_code}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>
            <Button onClick={confirmDesign} className="w-full" data-testid="se-confirm-design">Continue</Button>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default SubstituteDialog;
